import { Color, Spacing } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { FC, useMemo } from 'react';
import styled from 'styled-components';

import { ERROR_MESSAGES, ErrorType } from 'dashboard/components/PlatformSchemaEditor/constants';

const ErrorMessageContainer = styled.div`
  background-color: ${({ theme }) => theme.color.variants.danger.highlightLight};
  display: flex;
  padding: ${Spacing[3]};
  gap: ${Spacing[3]};
  margin-bottom: ${Spacing[3]};
  border-radius: 4px;
`;

const ErrorText = styled.div`
  font-weight: 500;
`;

const IndentedList = styled.ul`
  list-style-position: inside;
  margin-left: ${Spacing[3]};
`;

interface ErrorDisplayProps {
  errors: Record<string, ErrorType[]>;
}

export const ErrorDisplay: FC<ErrorDisplayProps> = ({ errors }) => {
  const deduplicatedErrors = useMemo(() => {
    return [...new Set(Object.values<ErrorType[]>(errors).flat())];
  }, [errors]);

  return deduplicatedErrors.length > 0 ? (
    <ErrorMessageContainer>
      <CircleAlertIcon color={Color.CoreRed800} size={16} />
      <div>
        <ErrorText>Please fix the following errors:</ErrorText>
        <IndentedList>
          {deduplicatedErrors.map((error) => (
            <li key={error}>{ERROR_MESSAGES[error]}</li>
          ))}
        </IndentedList>
      </div>
    </ErrorMessageContainer>
  ) : (
    <></>
  );
};
